import type { RoundupDriverGroupEnum } from '@repo/contracts/marketplace/offers/enums';
import { aprDriverEmptyValueString } from '../../constants';
import type { AllDrivers } from '../../types';
import { DRIVER_ROW_MAP, type DriverRows } from './config';

export const getDriverLayout = ({ driverGroup }: { driverGroup: RoundupDriverGroupEnum }) => {
  const driverRowMap = structuredClone(DRIVER_ROW_MAP);
  return driverRowMap[driverGroup];
};

export const getEmptyNotRelevantPurchaseOrIntroAPR = ({
  allDrivers,
  secondRow,
}: {
  allDrivers: AllDrivers;
  secondRow: DriverRows['desktop']['secondRow'];
}) => {
  // Being in second row means they are dismissible if no value
  const secondRowPurchaseOrIntroAPR = secondRow.filter(driver =>
    ['balanceTransferIntroAPR', 'purchaseIntroAPR'].includes(driver),
  );
  return secondRowPurchaseOrIntroAPR.filter(
    purchaseOrIntroAPR => allDrivers[purchaseOrIntroAPR].value === aprDriverEmptyValueString,
  );
};
